import React, { useState } from "react";
import { Button, Card, CardBody, Spinner, Alert, Input } from "reactstrap";
import axiosInstance from "../../request.jsx"; // ✅ your axios config
import { URL } from "../../api.jsx";

const StepStatus = () => {
  const [customerId, setCustomerId] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // ✅ Helper to show temporary message
  const showMessage = (msg, duration = 3000) => {
    setMessage(msg);
    setTimeout(() => setMessage(""), duration);
  };

  // ✅ Reject single customer by ID
  const rejectCustomer = () => {
    if (!customerId) {
      showMessage("Please enter a Customer ID");
      return;
    }
    setLoading(true);
    axiosInstance
      .post(`${URL.REJECT_ON_APP}?customerId=${customerId}`)
      .then((res) => {
        showMessage(res.data);
        setLoading(false);
        setCustomerId("");
      })
      .catch((err) => {
        console.error(err);
        showMessage("Failed to reject customer.");
        setLoading(false);
      });
  };

  // ✅ Run update for all customers
  const updateAll = () => {
    setLoading(true);
    axiosInstance
      .post(URL.RJECT_BY_LOAN)
      .then((res) => {
        showMessage(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        showMessage("Failed to update all customers.");
        setLoading(false);
      });
  };

  // ✅ Mark step status as rejected based on customer status
  const markRejectedByStatus = () => {
    setLoading(true);
    axiosInstance
      .post(URL.MARK_REJECTED_BY_STATUS)
      .then((res) => {
        showMessage(typeof res.data === "string" ? res.data : "Step status updated successfully");
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        showMessage("Failed to mark rejected by customer status.");
        setLoading(false);
      });
  };

  return (
    <Card style={{ width: "50%", margin: "20px auto" }}>
      <CardBody>
        <h4>Step Status Control</h4>
        {loading && <Spinner />}

        {/* Message alert at top */}
        {message && <Alert color="info">{message}</Alert>}

        {/* Reject Single Customer */}
        <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
          <Input
            type="number"
            placeholder="Enter Customer ID"
            value={customerId}
            onChange={(e) => setCustomerId(e.target.value)}
            style={{ width: "200px" }}
          />
          <Button color="danger" onClick={rejectCustomer}>
            Reject Customer
          </Button>
        </div>

        {/* Update All Customers */}
        <div style={{ marginTop: "20px" }}>
          <Button color="primary" onClick={updateAll}>
            Run Step Status Update (All Customers)
          </Button>
        </div>

        {/* Mark Rejected By Customer Status */}
        <div style={{ marginTop: "20px" }}>
          <Button color="warning" onClick={markRejectedByStatus}>
            Mark Rejected By Customer Status
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default StepStatus;
